<template>
  <div
    :style="{ width, height }"
    class="container"
  >
    <template v-if="uploadConf.qiniu_upload">
      <el-upload
        class="avatar-uploader"
        :action="uploadConf.qiniu_upload"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="uploadConf"
      >
        <img
          v-if="url"
          :src="url"
          class="avatar"
        />
        <i
          v-else
          class="el-icon-plus avatar-uploader-icon"
        ></i>
        <div
          class="el-upload__tip"
          slot="tip"
        >
          <slot name="tip"></slot>
        </div>
      </el-upload>
    </template>
    <div
      class="close-btn"
      v-if="url"
      @click.stop="removeUrl"
    >
      <i class="el-icon-error"></i>
    </div>
  </div>
</template>

<script>
import { localget, localset } from '@/utils/localStorage'
import { getQiniuToken } from './api'
import { nanoid } from 'nanoid'
export default {
  name: 'UploaderFile',
  data () {
    return {
      uploadType: '',
      uploadConf: {}
    }
  },

  props: {
    url: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    },
    height: {
      type: String,
      default: '150px'
    }
  },

  mounted () {
    const config = localget('qiniuConfig')
    if (config) {
      this.uploadConf = config
    } else {
      getQiniuToken().then((res) => {
        // this.uploadType = res.uploadType
        this.uploadConf = res
        localset('qiniuConfig', this.uploadConf, 1800)
      })
    }
  },
  methods: {
    removeUrl () {
      this.$emit('update:url', '')
    },
    beforeAvatarUpload: function (file) {
      // this.uploadConf.key = nanoid()
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)
      this.uploadConf.key = nanoid() + '.' + fileExtension

      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isJPG && !isPNG) {
        this.$message.error('图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 10MB!')
        return false
      }
    },
    handleAvatarSuccess: function (res, file) {
      let url = this.uploadConf.domain + '/' + res.key
      this.imgUrl = url
      this.$emit('update:url', url)
    },
    handleError: function (res) {
      this.$message.error({
        message: '上传失败',
        duration: 2000,
        type: 'warning'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container ::v-deep {
  width: 150px;
  height: 150px;
  position: relative;
  padding-bottom: 0 !important;
  .close-btn {
    position: absolute;
    top: -7px;
    right: -10px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
    i {
      font-size: 20px;
      color: #606266;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}
</style>
